import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "file-manager__list" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 아이폰에서 촬영한 영상이 보이지 않을 때 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("a", {
  class: "-link -royalBlue",
  target: "_blank",
  href: "https://support.apple.com/ko-kr/HT207022",
  style: {"font-weight":"600"}
}, "여기", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("를 눌러 ")
const _hoisted_8 = /*#__PURE__*/_createVNode("b", null, "[미디어 캡처하기]", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("를 참고하세요")
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "file-image",
  src: "/images/new/file.svg"
}, null, -1)
const _hoisted_11 = { class: "col-body file-info" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "pi pi-trash" }, null, -1)
const _hoisted_13 = { class: "p-py-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 처방전 보기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_FileViewerDialog = _resolveComponent("FileViewerDialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isSecondOpinion)
        ? (_openBlock(), _createBlock("small", _hoisted_3, _toDisplayString(_ctx.l("desc.a")) + "}", 1))
        : _createCommentVNode("", true),
      (!_ctx.isPx)
        ? (_openBlock(), _createBlock("small", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.state.list,
      onRowSelect: _ctx.onSelectedRow,
      dataKey: "FileKey",
      selection: _ctx.state.select,
      "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.select = $event)),
      selectionMode: "single",
      class: "data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "Image",
          header: ""
        }, {
          body: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "FileInfo",
          header: ""
        }, {
          body: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_11, [
              _createVNode("span", null, _toDisplayString(slotProps.data.Title), 1),
              _createVNode("span", null, _toDisplayString(slotProps.data.DataType), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "FileKey",
          header: ""
        }, {
          body: _withCtx((slotProps) => [
            (!slotProps.data.RefKeyValue3 || _ctx.isLive)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "file-remove",
                  onClick: _cache[1] || (_cache[1] = 
              () => {
                _ctx.openModal();
              }
            )
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Dialog, {
              header: _ctx.l('remove'),
              visible: _ctx.displayModal,
              "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayModal = $event)),
              style: { width1: '50vw' },
              modal: true
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_Button, {
                  label: _ctx.t('No'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal())),
                  class: "p-button-text"
                }, null, 8, ["label"]),
                _createVNode(_component_Button, {
                  label: _ctx.t('Yes'),
                  class: "p-button-danger",
                  icon: "pi pi-check",
                  onClick: ($event: any) => (_ctx.deleteFile(slotProps.data.FileKey)),
                  autofocus: ""
                }, null, 8, ["label", "onClick"])
              ]),
              default: _withCtx(() => [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.l("removeHeader")), 1)
              ]),
              _: 2
            }, 1032, ["header", "visible"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onRowSelect", "selection"]),
    (_ctx.state.visibleFull)
      ? (_openBlock(), _createBlock(_component_FileViewerDialog, {
          key: 0,
          file: _ctx.state.select,
          onClose: _ctx.FileViewerDialogClose
        }, _createSlots({ _: 2 }, [
          (_ctx.state.isPx)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _hoisted_14
                ])
              }
            : undefined
        ]), 1032, ["file", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}